(ns teamoesterreich.element.backend-file
  (:require ["react" :as react]
            ["react-oidc-context" :as roc]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.download :as h-download]))

(defn use-download-url [doc-hash]
  (let [auth (roc/useAuth)
        [url set-url] (react/useState nil)]
    (react/useEffect (fn []
                       (h-download/fetch-download-url (when-let [user (.-user auth)] user)
                                                      (when (not-empty doc-hash)
                                                        (str "/document/" doc-hash "/download-url"))
                                                      (fn [url]
                                                        (set-url url))))
                     #js[doc-hash (some-> auth (.-user) (.-access_token)) set-url])
    url))

(defn fetch-blob [auth doc-hash preview? callback]
  (let [url (when (not-empty doc-hash)
              (if preview?
                (str backend/BASE_URL "/document/" doc-hash "/file/preview")
                (str backend/BASE_URL "/document/" doc-hash "/file")))]

    (h-download/fetch-blob (when-let [user (.-user auth)] user) url callback)
    ))

(defn wrapper [{:keys [hash preview?]} inner]
  (let [auth (roc/useAuth)
        [blob-info set-blob-info] (react/useState nil)]
    (react/useEffect
      (fn []
        (fetch-blob auth hash preview?
                    (fn [blob]
                      (when blob
                        (set-blob-info
                          (fn [old]
                            (when old
                              (js/URL.revokeObjectURL (:url old)))

                            {:url          (js/URL.createObjectURL blob)
                             :content-type (.-type blob)})))
                      ))

        (fn []
          (set-blob-info (fn [old]
                           (when old
                             (js/URL.revokeObjectURL (:url old)))))))
      #js[hash preview? set-blob-info])

    (inner blob-info)
    ))

(defn img [{:keys [hash preview?] :or {preview? true} :as props}]
  [:f> wrapper {:hash hash :preview? preview?}
   (fn [{:keys [url]}]
     [:img (assoc (dissoc props :hash :preview?)
             :src url)])])

(defn download-wrapper [doc-hash inner]
  (let [url (use-download-url doc-hash)]
    (inner url)))